import { convertFromRaw } from "draft-js";
import { I18n } from "@assets/strings";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";
import { TextSection } from "@domain/lms/article/article";
import { RichTextInput } from "@ui/components/inputs/draft/richTextInput";
import { useEditorController } from "@ui/pages/lms/article/articleEditorPage/articleEditorController/editorControllerContext";

interface TextSectionEditorProps extends React.HTMLAttributes<HTMLDivElement> {
	section: TextSection;
	collapsed?: boolean;
	onExtend?: () => void;
}
export const TextSectionEditor: React.FC<TextSectionEditorProps> = ({
	section,
	collapsed = false,
	onExtend,
	...htmlProps
}) => {
	const articleController = useEditorController();
	const textController = useMemo(() => articleController.textSectionController(section), [section]);
	if (typeof section.content === "string") section.content = convertFromRaw(JSON.parse(section.content));
	return (
		<Container {...htmlProps}>
			<StyledTextInput
				collapsed={collapsed}
				onClick={() => collapsed && onExtend && onExtend()}
				placeholder={I18n.t("course.editor.section.text.placeholder")}
				value={section.content}
				onChange={(v) => textController.setContent(v)}
				onKeyDown={(e) => {
					if (e.key === "Backspace" && !section.content.hasText()) {
						textController.removeSection();
					}
				}}
				readOnly={collapsed}
				richStyleEnabled={!collapsed}
			/>
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	margin: -10px -16px;
	line-height: 24px;
`;

const StyledTextInput = styled(RichTextInput)<{ collapsed: boolean }>`
	cursor: text;

	.public-DraftEditor-content,
	.public-DraftEditorPlaceholder-root {
		padding: 10px 32px 10px 16px;
	}
	${({ collapsed }) =>
		collapsed
			? css`
					height: 39px;
					overflow: hidden;
				`
			: css`
					min-height: 80px;
				`}
`;
